/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Inject, Injectable, Optional } from '@angular/core';
import { ENVIRONMENT } from '@com-delta-idp/angular-core/environment/tokens';
import { Config } from '../data-models/config.interfaces';
import { UrlUtilsService } from '../url-utils/url.utils.service';

/**
 * Service for interacting with configuration.
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  /**
   * ConfigService constructor.
   */
  constructor(
    private urlUtils: UrlUtilsService,
    @Optional() @Inject('REQUEST') private request: any,
    @Optional() @Inject(ENVIRONMENT) private environment: any,
    @Optional() @Inject('APP_ENVIRONMENT') private appEnvironment: any
  ) {
    if (this.appEnvironment) {
      this.environment = appEnvironment;
    }
  }

  /**
   * Get configuration for current site.
   */
  getConfig(): Config {
    const config = this.environment;

    Object.keys(this.environment).forEach((key) => {
      const paramValue = this.urlUtils.getUrlParameter(key);

      const envValue = this.environment[key];

      if (paramValue) {
        config[key] = paramValue;
      } else if (envValue) {
        config[key] = envValue;
      }
    });

    return config;
  }

  /**
   * Get a configuration value by it's app and key name.
   */
  // eslint-disable-next-line complexity
  getConfigValueByKey(key: string, app?: string): string {
    const port =
      this.request && this.request.app.settings.port !== 80
        ? ':' + this.request.app.settings.port
        : '';
    const hostname = this.request
      ? encodeURI(this.request.protocol + '://' + this.request.hostname + port)
      : '';

    if (app && this.environment[app]) {
      const url = this.urlUtils.getUrlParameter(
        key,
        // @ts-ignore
        this.environment[app][key]
      );
      return hostname ? hostname + url : url;
    }

    return hostname
      ? hostname + this.urlUtils.getUrlParameter(key, this.environment[key])
      : this.urlUtils.getUrlParameter(key, this.environment[key]);
  }
}
